module.exports = __webpack_public_path__ + "img/l.945a32b6.jpg";